import { ACTIONS } from '../constants/events-calendar-details';

const INITIAL_STATE = {
  detailsList: { details: [], params: {}, pager: null, loading: false, error: null },
  activeDetail: { detail: null, loading: false, error: null },
};

export const eventsCalendarDetails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /* ---------- LIST FETCH ---------- */
    case ACTIONS.EVENTS_CALENDAR_DETAILS_FETCH_START:
      return {
        ...state,
        detailsList: {
          ...state.detailsList,
          loading: true,
          error: null,
          params: action.payload || {},
        },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAILS_FETCH_SUCCESS:
      return {
        ...state,
        detailsList: {
          ...state.detailsList,
          details: action.payload.results,
          pager: action.payload.paginator,
          loading: false,
          error: null,
        },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAILS_FETCH_FAILURE:
      return {
        ...state,
        detailsList: { ...state.detailsList, loading: false, error: action.payload },
      };

    /* ---------- SINGLE FETCH ---------- */
    case ACTIONS.EVENTS_CALENDAR_DETAIL_FETCH_START:
      return { ...state, activeDetail: { detail: null, loading: true, error: null } };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_FETCH_SUCCESS:
      return { ...state, activeDetail: { detail: action.payload, loading: false, error: null } };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_FETCH_FAILURE:
      return { ...state, activeDetail: { detail: null, loading: false, error: action.payload } };

    /* ---------- CREATE / UPDATE / DELETE ---------- */
    case ACTIONS.EVENTS_CALENDAR_DETAIL_CREATE_START:
    case ACTIONS.EVENTS_CALENDAR_DETAIL_UPDATE_START:
    case ACTIONS.EVENTS_CALENDAR_DETAIL_DELETE_START:
      return {
        ...state,
        activeDetail: { ...state.activeDetail, loading: true, error: null, successMessage: null },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_CREATE_SUCCESS:
      return {
        ...state,
        detailsList: {
          ...state.detailsList,
          details: [...state.detailsList.details, action.payload],
        },
        activeDetail: {
          detail: action.payload,
          loading: false,
          error: null,
          successMessage: 'APP.EVENTS_CALENDAR_DETAIL.SUCCESS-ADD',
        },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_UPDATE_SUCCESS:
      return {
        ...state,
        detailsList: {
          ...state.detailsList,
          details: state.detailsList.details.map(d =>
            d.id === action.payload.id ? action.payload : d
          ),
        },
        activeDetail: {
          detail: action.payload,
          loading: false,
          error: null,
          successMessage: 'APP.EVENTS_CALENDAR_DETAIL.SUCCESS-EDIT',
        },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_DELETE_SUCCESS:
      return {
        ...state,
        detailsList: {
          ...state.detailsList,
          details: state.detailsList.details.filter(d => d.id !== action.payload.id),
        },
        activeDetail: {
          detail: null,
          loading: false,
          error: null,
          successMessage: 'APP.EVENTS_CALENDAR_DETAIL.SUCCESS-DELETE',
        },
      };

    case ACTIONS.EVENTS_CALENDAR_DETAIL_CREATE_FAILURE:
    case ACTIONS.EVENTS_CALENDAR_DETAIL_UPDATE_FAILURE:
    case ACTIONS.EVENTS_CALENDAR_DETAIL_DELETE_FAILURE:
      return {
        ...state,
        activeDetail: {
          ...state.activeDetail,
          loading: false,
          error: action.payload,
          successMessage: null,
        },
      };

    /* ---------- RESET ---------- */
    case ACTIONS.EVENTS_CALENDAR_DETAIL_RESET:
      return { ...state, activeDetail: { detail: null, loading: false, error: null } };

    default:
      return state;
  }
};
